<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" icon dark v-bind="attrs" v-on="on">
        <v-icon color="error">mdi-close</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Remove payment method from your account?
      </v-card-title>
      <v-card-text>
        This will remove your <span class="text-capitalize font-weight-bold">{{paymentMethod.card.brand}}</span> card ending in <span class="font-weight-bold">{{paymentMethod.card.last4}}</span> with an expiration date of <span class="font-weight-bold">{{paymentMethod.card.expMonth}}/{{paymentMethod.card.expYear}}</span> from your account.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">
          Cancel
        </v-btn>
        <v-btn color="error" text @click="remove">
          Remove
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "RemovePaymentMethodDialog",
  props: ['paymentMethod'],
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    ...mapActions("auth", ["removePaymentMethod"]),
    remove() {
      this.removePaymentMethod(this.paymentMethod.id)
      .then(() => this.dialog = false)
    }
  }
};
</script>

<style></style>
